module.exports = __webpack_public_path__ + "assets/fonts/glyphicons-halflings-regular.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/fonts/glyphicons-halflings-regular.svg
 ** module id = 757
 ** module chunks = 1
 **/